import React from 'react';
import { AiOutlineLock, AiOutlineUnlock } from 'react-icons/ai';
import { Checkbox, Flex, Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const SearchColumnCheckbox = ({
  name,
  checked = false,
  locked = false,
  nested = false,
  onChange = () => {}
}) => (
  <Flex pl={nested ? 4 : 0}>
    <Icon as={locked ? AiOutlineLock : AiOutlineUnlock} color={locked ? 'black' : 'greyScale.300'} h={6} w={6} />
    <Checkbox
      colorScheme="blackAlpha"
      dusk={`search-column-checkbox-${name}`}
      isChecked={checked}
      ml={2}
      onChange={e => onChange(e.target.name, e.target.checked)}
    >
      {name}
    </Checkbox>
  </Flex>
);

SearchColumnCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  checked: PropTypes.bool,
  nested: PropTypes.bool,
  onChange: PropTypes.func
};

export default SearchColumnCheckbox;
